import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { init as initSentry, ErrorBoundary } from './lib/sentry';

// Initialise Sentry BEFORE the React tree mounts so any sync render errors
// are captured. With no DSN configured this is a no-op (see ./lib/sentry).
initSentry();

const fallback = (
  <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'sans-serif' }}>
    <h2>Something went wrong.</h2>
    <p>The team has been notified.</p>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary fallback={fallback}>
    <App />
  </ErrorBoundary>
);
